<h2 class="dialog-header">{{consts.TITLE}}
    <mat-icon
        svgIcon="hub_close"
        class="dialog-close-button"
        (click)="onClose()"
    >
    </mat-icon>
</h2>
<!-- Tab group -->
<div class="dialog-body">
    <mat-tab-group
        mat-align-tabs="center"
        dynamicHeight="false"
    >
        <mat-tab class="clock-dialog-tab-label">
            <ng-template mat-tab-label>
                <mat-icon
                    svgIcon="hub_globe"
                    class="clock-dialog-tab-label-icon"
                >
                </mat-icon>
                {{consts.ACTION_EDIT_FAVORITES}}
            </ng-template>
            <app-clock-favorites-tab
                [settings]="{
                    'favorites': settings.favorites || [],
                    'recents': settings.recent || []
                }"
                (changeSettings)="onFavoritesChanged($event)"
            >
            </app-clock-favorites-tab>
        </mat-tab>
        <mat-tab class="clock-dialog-tab-label">
            <ng-template mat-tab-label>
                <mat-icon
                    svgIcon="hub_globe"
                    class="clock-dialog-tab-label-icon"
                >
                </mat-icon>
                {{consts.ACTION_EDIT_FORMAT}}
            </ng-template>
            <app-clock-settings-tab
                [settings]="{
                    'dateFormat': settings.dateFormat,
                    'timeFormat': settings.timeFormat,
                    'showDayOfWeek': settings.showDayOfWeek
                }"
                (changeSettings)="onSettingsChanged($event)"
            >
            </app-clock-settings-tab>
        </mat-tab>
    </mat-tab-group>
    <div class="row">
        <div class="col text-center">
            <button
                mat-raised-button
                class="clock-dialog-save-btn"
                (click)="onSave()"
            >
                {{consts.BUTTON_SAVE}}
            </button>
        </div>
    </div>
</div>
